export interface Model {
    id: string;
    name: string; // e.g. "OpenAI: o3 Pro"
    [key: string]: any;
}

export interface ProviderOption {
    provider: string;
    models: Model[];
}

export async function fetchModels(): Promise<Model[]> {
    const res = await fetch('https://openrouter.ai/api/v1/models');
    if (!res.ok) throw new Error('Failed to fetch models');
    const data = await res.json();
    return data.data;
}

export function extractProviders(models: Model[]): string[] {
    // Extract provider from name (before ':')
    const providers = Array.from(
        new Set(
            models
                .map(m => m.name.split(':')[0].trim())
                .filter(Boolean)
        )
    );
    return providers;
}

export function getModelsForProvider(models: Model[], provider: string): Model[] {
    return models.filter(m => m.name.split(':')[0].trim() === provider).sort((a, b) => {
        const aPrice = a.pricing?.prompt || 0;
        const bPrice = b.pricing?.prompt || 0;
        return aPrice - bPrice;
    });
}
